import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import WalletIcon from './assets/Wallet.svg';
import ReportIcon from './assets/Paper.svg';
import NavigationBarWrapper from './styles';

const NavigationBar: React.FC = () => {
	const { pathname } = useLocation();

	return (
		<NavigationBarWrapper>
			<Link
				className={`nav-item${
					pathname === '/reports' ? ' active' : ''
				}`}
				to='/reports'
			>
				<img src={ReportIcon} alt='' />
			</Link>
			<Link
				className={`nav-item${pathname === '/' ? ' active' : ''}`}
				to='/'
			>
				<img src={WalletIcon} alt='' />
			</Link>
		</NavigationBarWrapper>
	);
};

export default NavigationBar;
